module.exports = __webpack_public_path__ + "static/media/karljohan.23ac96ee.jpg";